enum DataTags {
  UserData = 'user_data',
  Profiles = 'profiles',
  Settings = 'settings',
  Assessments = 'assessments',
}

export default DataTags
